export const serviceCategories = {
  0: 'Others',
  1: 'Rewards',
  2: 'Recording/Timing',
  3: 'Before/After race',
  4: 'Transportation',
  5: 'Stations',
  6: 'Facilities',
};
